// eslint-disable-next-line
export default [
	{
		id: 1,
		productName: "Coke zero",
		productSize: "30CL",
		productPrice: 350,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 104,
		cartProductQuantity: 0,
	},
	{
		id: 2,
		productName: "Yoghurt",
		productSize: "50CL",
		productPrice: 700,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 35,
		cartProductQuantity: 0,
	},
	{
		id: 3,
		productName: "Chivita",
		productSize: "35CL",
		productPrice: 800,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 0,
		cartProductQuantity: 0,
	},
	{
		id: 4,
		productName: "Coke zero",
		productSize: "30CL",
		productPrice: 350,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 104,
		cartProductQuantity: 0,
	},
	{
		id: 5,
		productName: "Yoghurt",
		productSize: "50CL",
		productPrice: 700,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 35,
		cartProductQuantity: 0,
	},
	{
		id: 6,
		productName: "Chivita",
		productSize: "35CL",
		productPrice: 800,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 10,
		cartProductQuantity: 0,
	},
	{
		id: 7,
		productName: "Coke zero",
		productSize: "30CL",
		productPrice: 350,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 104,
		cartProductQuantity: 0,
	},
	{
		id: 8,
		productName: "Yoghurt",
		productSize: "50CL",
		productPrice: 700,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 35,
		cartProductQuantity: 0,
	},
	{
		id: 9,
		productName: "Chivita",
		productSize: "35CL",
		productPrice: 800,
		productImage: "/svgs/cart-product-image.svg",
		productQuantity: 10,
		cartProductQuantity: 0,
	},
];
